import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Thumbnail from '../Thumbnail/Thumbnail';
import withBoundary from 'component/ErrorBoundary/withBoundary';
import { LAYOUTS } from 'store/modules/video-layout';
import { FILMSTRIP_TYPE } from 'store/modules/filmstrip';
import { useSelector } from 'react-redux';
const TileView = (props) => {
  const { stageParticipants } = props;
  const { gridDimensions } = useSelector(
    (state) => state['features/filmstrip'].tileViewDimensions
  );
  return (
    <div className="filmstrip__videos" id="remoteVideos">
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        className="filmstrip__videos remote-videos"
        sx={{
          flexDirection: gridDimensions?.columns == 1 ? 'column' : 'row',
          flexWrap: stageParticipants?.length <= 2 ? 'nowrap' : 'wrap'
        }}
        spacing={1}>
        {stageParticipants.map((item, index) => (
          <Grid item xs key={index}>
            <Thumbnail
              _currentLayout={LAYOUTS.TILE_VIEW}
              filmstripType={FILMSTRIP_TYPE.MAIN}
              key={`remote_${item}`}
              participantID={item}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};
export default React.memo(withBoundary(TileView));
TileView.propTypes = {
  stageParticipants: PropTypes.array
};
